import Vue from 'vue';
import * as C from '../constants';
import defaultState from '../ski/skipass/defaultState';
import { TWENTY_DOMAIN_FAILURE } from '../constants';

export default {
  [C.XML_PRODUCTS_LOAD_PENDING](state) {
    state.xmlProducts = {
      ...state.xmlProducts,
      itemsLoading: true,
      itemsError: false,
      items: [],
    };
  },
  [C.XML_PRODUCTS_LOAD_SUCCESS](state, payload) {
    state.xmlProducts[payload.type] = {
      ...state.xmlProducts,
      itemsLoading: false,
      itemsError: false,
      items: payload.items,
    };
  },
  [C.XML_PRODUCTS_LOAD_FAILURE](state) {
    state.xmlProducts = {
      ...state.xmlProducts,
      itemsLoading: false,
      itemsError: false,
      items: [],
    };
  },
  // XML Channels
  [C.XML_CHANNELS_LOAD_PENDING](state) {
    state.xmlChannels = {
      ...state.xmlChannels,
      itemsLoading: true,
      itemsError: false,
      items: [],
    };
  },
  [C.XML_CHANNELS_LOAD_SUCCESS](state, payload) {
    state.xmlChannels = {
      ...state.xmlChannels,
      itemsLoading: false,
      itemsError: false,
      items: payload,
    };
  },
  [C.XML_CHANNELS_LOAD_FAILURE](state) {
    state.xmlChannels = {
      ...state.xmlChannels,
      itemsLoading: false,
      itemsError: false,
      items: [],
    };
  },
  [C.SKI_PASS_RESET_STATE](state) {
    Object.assign(state, defaultState());
  },
  // region Countries
  [C.TWENTY_COUNTRIES_LOAD_PENDING](state) {
    Vue.set(state, 'countries', {
      ...state.countries,
      items: [],
      itemsLoading: true,
      itemsError: undefined,
    });
  },

  [C.TWENTY_COUNTRIES_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'countries', {
      ...state.countries,
      items: payload,
      itemsLoading: false,
    });
  },

  [C.TWENTY_COUNTRIES_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'countries', {
      ...state.countries,
      itemsLoading: false,
      itemsError: payload,
    });
  },
  // endregion

  // region Areas
  [C.TWENTY_AREAS_LOAD_PENDING](state) {
    Vue.set(state, 'areas', {
      ...state.areas,
      items: [],
      itemsLoading: true,
      itemsError: undefined,
    });
  },

  [C.TWENTY_AREAS_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'areas', {
      ...state.areas,
      items: payload,
      itemsLoading: false,
    });
  },

  [C.TWENTY_AREAS_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'areas', {
      ...state.areas,
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.TWENTY_AREAS_CLEAR](state) {
    Vue.set(state, 'areas', {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
    });
  },
  // endregion

  // region Sites
  [C.TWENTY_SITES_LOAD_PENDING](state) {
    Vue.set(state, 'sites', {
      ...state.areas,
      items: [],
      itemsLoading: true,
      itemsError: undefined,
    });
  },

  [C.TWENTY_SITES_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'sites', {
      ...state.sites,
      items: payload,
      itemsLoading: false,
    });
  },

  [C.TWENTY_SITES_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'sites', {
      ...state.sites,
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.TWENTY_SITES_CLEAR](state) {
    Vue.set(state, 'sites', {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.TWENTY_DOMAIN_SUCCESS](state, payload) {
    Vue.set(state, 'domains', {
      ...state.domains,
      items: payload,
      itemsLoading: false,
    });
  },

  [C.TWENTY_DOMAIN_FAILURE](state, payload) {
    Vue.set(state, 'domains', {
      ...state.domains,
      itemsLoading: false,
      itemsError: payload,
    });
  },
  // endregion
};



// WEBPACK FOOTER //
// ./src/store/modules/twenty/mutations.js